"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Tooltip._InternalPanelDoNotUseOrYouWillBeFired, {
    title: "prompt text"
  }), /*#__PURE__*/_react.default.createElement("span", null, "Tooltip will show on mouse enter."));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorBgSpotlight', 'colorTextLightSolid'],
  key: 'default'
};
var _default = exports.default = componentDemo;